import { createSlice } from '@reduxjs/toolkit';
import { GuidesState } from './models';
import { addThunkCases } from './thunks';

export const initialState: GuidesState = {
  status: 'idle',
  message: null,
  sections: [],
  categories: [],
  uncategorized: [],
  categoriesOrder: [],
  contents: [],
};

// Redux Slice
export const slice = createSlice({
  name: 'guides',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearStatus: state => {
      state.status = 'idle';
      state.message = null;
    },
  },
  extraReducers: addThunkCases,
});

// redux selectors
export const selectGuidesSections = (state: { guides: GuidesState }) =>
  state.guides.sections;
export const selectGuidesCategories = (state: { guides: GuidesState }) => ({
  categories: state.guides.categories,
  categoriesOrder: state.guides.categoriesOrder,
  uncategorized: state.guides.uncategorized,
});
export const selectGuidesContents = (state: { guides: GuidesState }) =>
  state.guides.contents;

// auto-generated redux actions
export const { clearStatus } = slice.actions;
